import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { useCallback } from "react";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { AppType } from "client/Api/Apps/common";
import { getHubUrlForKnowledgeItem } from "client/Features/Hub/KnowledgeItems/KnowledgeItemsPage";
import { HubDataSource } from "client/Api/Hub/hub";
import { navigateTo } from "client_legacy/ndaw/navigator";

export type KnowledgeItemNavigationHandlerProps = {
	id: number;
}
	& RecentlyOpenedItemConfigurationProps;

export function useKnowledgeItemNavigationHandler(props: KnowledgeItemNavigationHandlerProps): (() => void) {
	const {
		id
	} = props;

	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();
	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.Hub });
			registerRecentlyOpenedItem(recentlyOpenedItem);
			navigateToKnowledgeItem(id);
		},
		[
			addAnalyticsAppEvent,
			id,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}

export function navigateToKnowledgeItem(id: number): void {
	const url: string = getHubUrlForKnowledgeItem({
		source: HubDataSource.KnowledgeItem,
		itemId: id
	});

	navigateTo(url);
}